import React from 'react';
import Icon from '../../../components/AppIcon';

const RiskHeatmap = ({ riskData, onDrillDown }) => {
  const getRiskColor = (score) => {
    if (score >= 70) return 'bg-gradient-to-br from-error to-error/80 text-error-foreground shadow-lg shadow-error/30';
    if (score >= 40) return 'bg-gradient-to-br from-warning to-warning/80 text-warning-foreground shadow-lg shadow-warning/30';
    return 'bg-gradient-to-br from-success to-success/80 text-success-foreground shadow-lg shadow-success/30';
  };

  const getRiskBorderColor = (score) => {
    if (score >= 70) return 'border-error/30 hover:border-error';
    if (score >= 40) return 'border-warning/30 hover:border-warning';
    return 'border-success/30 hover:border-success';
  };

  const getRiskLabel = (score) => {
    if (score >= 70) return 'Tinggi';
    if (score >= 40) return 'Sedang';
    return 'Rendah';
  };

  return (
    <div className="card bg-gradient-to-br from-card to-muted/30 shadow-xl border-2">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold mb-2 bg-gradient-to-r from-foreground to-muted-foreground bg-clip-text text-transparent">Peta Risiko Komprehensif</h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Visualisasi risiko berdasarkan analisis AI terhadap semua modul penilaian
          </p>
        </div>
        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-warning to-warning/60 flex items-center justify-center shadow-lg animate-pulse">
          <Icon name="AlertTriangle" size={28} className="text-warning-foreground" />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {riskData?.map((risk) => (
          <button
            key={risk?.id}
            onClick={() => onDrillDown(risk?.id)}
            className={`p-6 rounded-2xl border-2 ${getRiskBorderColor(risk?.score)} transition-all duration-300 text-left group hover:shadow-2xl transform hover:scale-105 bg-gradient-to-br from-card to-muted/20`}
          >
            <div className="flex items-start justify-between mb-4">
              <div className={`w-14 h-14 rounded-xl ${getRiskColor(risk?.score)} flex items-center justify-center transform group-hover:rotate-12 transition-transform duration-300`}>
                <Icon name={risk?.icon} size={26} />
              </div>
              <span className={`px-4 py-1.5 rounded-full text-xs font-bold ${getRiskColor(risk?.score)}`}>
                {getRiskLabel(risk?.score)}
              </span>
            </div>

            <h3 className="text-lg font-bold mb-2 group-hover:text-primary transition-colors">
              {risk?.category}
            </h3>
            <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
              {risk?.description}
            </p>

            <div className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground font-medium">Skor Risiko</span>
                <span className="font-bold data-text text-lg">{risk?.score}/100</span>
              </div>
              <div className="w-full h-3 bg-muted rounded-full overflow-hidden shadow-inner">
                <div
                  className={`h-full transition-all duration-700 ${getRiskColor(risk?.score)}`}
                  style={{ width: `${risk?.score}%` }}
                />
              </div>
            </div>

            <div className="mt-4 flex items-center gap-2 text-sm text-primary font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <span>Lihat Detail</span>
              <Icon name="ChevronRight" size={18} className="transform group-hover:translate-x-1 transition-transform" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RiskHeatmap;